var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14879447,0.25 C9.40660869,0.25 12.0475889,2.89098024 12.0475889,6.14879447 C12.0475889,7.25653357 11.7422463,8.29295608 11.2111357,9.17848721 L15.0048576,12.6549484 L15.0816325,12.7363805 C15.3137771,13.0221864 15.3078016,13.4424782 15.0516441,13.7221261 C14.7698709,14.0297388 14.2920792,14.0506858 13.9844664,13.7689126 L13.9844664,13.7689126 L10.2714026,10.3677881 C9.20797938,11.4070666 7.75318793,12.0475889 6.14879447,12.0475889 C2.89098024,12.0475889 0.25,9.40660869 0.25,6.14879447 C0.25,2.89098024 2.89098024,0.25 6.14879447,0.25 Z M6.14879447,1.76066688 C3.72529852,1.76066688 1.76066688,3.72529852 1.76066688,6.14879447 C1.76066688,8.57229042 3.72529852,10.5369221 6.14879447,10.5369221 C8.57229042,10.5369221 10.5369221,8.57229042 10.5369221,6.14879447 C10.5369221,3.72529852 8.57229042,1.76066688 6.14879447,1.76066688 Z",
    id: "Combined-Shape",
    fill: "#8D8E97",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.7fa164c8f9fc18e61ff2d3a372277de0.svg";
export { ForwardRef as ReactComponent };